import { ButtonHTMLAttributes, PropsWithChildren } from 'react';

type Props = PropsWithChildren<ButtonHTMLAttributes<HTMLButtonElement> & { variant?: 'primary' | 'secondary' | 'ghost' | 'danger'; size?: 'sm' | 'md' }>;
export function Button({ children, className = '', variant = 'primary', size = 'md', ...props }: Props) {
  return <button className={`button button--${variant} button--${size} ${className}`} {...props}>{children}</button>;
}
